import { render, staticRenderFns } from "./LomEventsEdit.vue?vue&type=template&id=4919cb37"
import script from "./LomEventsEdit.vue?vue&type=script&lang=js"
export * from "./LomEventsEdit.vue?vue&type=script&lang=js"
import style0 from "./LomEventsEdit.vue?vue&type=style&index=0&id=4919cb37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports